import './percentagePill.scss';

import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';

const getPercentageHelperData = percent => {
    switch (true) {
        case percent === 0:
            return { description: 'equal', value: percent.toFixed(2), sign: '' };
        case percent > 0:
            return { description: 'positive', value: percent.toFixed(2), sign: '+' };
        case percent < 0:
            return { description: 'negative', value: (-percent).toFixed(2), sign: '-' };
        default:
            return { description: 'other', value: undefined, sign: '' };
    }
};

const PercentagePill = ({ percent, compact = false, product = false }) => {

    const { description, value, sign } = getPercentageHelperData(percent);

    const stringPercent = value ? `${sign} ${value.replace('.', ',')} % `: '- %';

    const className = classNames(
        'brokerIA-percentagePill',
        `brokerIA-percentagePill--${description}`,
        {
            'brokerIA-percentagePill--compact': !!compact,
            'brokerIA-percentagePill--product': !!product
        }
    );
    return (
        <div className={className}>
            <div className="brokerIA-percentagePill__text">
                {stringPercent}
            </div>
        </div>
    );
};
PercentagePill.propTypes = {
    percent: PropTypes.number.isRequired,
    compact: PropTypes.Boolean,
    product: PropTypes.Boolean
};

export default PercentagePill;
